export default __webpack_public_path__ + "static/media/client-6.572fe5d3.png";